import styled from 'styled-components'

import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { toRem } from '@/config/layout'
import { VisibleScrollbarStyle } from '@/styles/scrollbar'

const BigNumber = styled.span`
  font-size: 2rem;
  line-height: 2rem;
  width: ${toRem(36)};
`

const ContactEditButton = styled(Button).attrs({
  variant: 'Tertiary',
  prefixIcon: ['fal', 'user-pen'],
  inline: true,
})`
  margin-top: ${({ theme }) => toRem(theme.UI.Spacing.Space3)};
  padding: 0;
  min-height: auto;
  justify-content: flex-start;
`

const ScrollableContainer = styled.div`
  ${VisibleScrollbarStyle}
`

export { BigNumber, ContactEditButton, ScrollableContainer }
